import SupportBannerSecondary from './SupportBannerSecondary'

export default SupportBannerSecondary
